export default __webpack_public_path__ + "static/media/almostNaked.53fc41a8.png";